module.exports = __webpack_public_path__ + "ff22ac51493a8720af4c05708d7c185e.png";